import React from 'react';
import { Typography } from '@mui/material';
import BookmarkBorder from '@mui/icons-material/BookmarkBorder';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';

/**
 * Text-label style resource selector for subtle display.
 * Use ResourceSelectorButton for prominent button-style display.
 */
const ResourceSelectorLabel = React.forwardRef(function ResourceSelectorLabel(
  { onClick, resource, sx, ...props },
  ref,
) {
  const { t } = useTranslation();

  return (
    <Typography
      ref={ref}
      component="span"
      variant="body2"
      onClick={onClick}
      sx={{
        color: 'text.secondary',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        '&:hover': {
          textDecoration: 'underline',
        },
        ...sx,
      }}
      {...props}
    >
      <BookmarkBorder sx={{ fontSize: 16 }} />
      {resource?.name || t('resource_selection_headline')}
      <ExpandMoreIcon sx={{ fontSize: 14 }} />
    </Typography>
  );
});

export default ResourceSelectorLabel;
